import React, { createContext, useContext } from "react";

const UserRolesContext = createContext([]);
const UserRolesLoadingContext = createContext(false);

export const UserRolesProvider = ({ roles = [], loading = false, children }) => (
  <UserRolesLoadingContext.Provider value={loading}>
    <UserRolesContext.Provider value={roles}>
      {children}
    </UserRolesContext.Provider>
  </UserRolesLoadingContext.Provider>
);

export const useUserRoles = () => useContext(UserRolesContext);
export const useUserRolesLoading = () => useContext(UserRolesLoadingContext);
